import React from 'react';
import Chat from './Chat';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Chat />
      </header>
    </div>
  );
}

export default App;
